export default "__VITE_ASSET__DJcOFZf$__"